import React from "react";
import { Link, graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { MDXRenderer } from "gatsby-plugin-mdx";
import Layout from "../../components/layout";
import Nav from "../../components/nav";
import Seo from "../../components/seo";
import * as styles from "./wall-painting-template.module.css";
import arrow from "../../images/arrow.svg";

const WallPaintingPage = ({ data }) => {
  const { mdx: painting } = data;
  const paintingLinks = data.allMdx.nodes.map((node) => ({
    slug: node.slug,
    position: node.frontmatter.position,
  }));

  const currentPageIndex = paintingLinks.findIndex(
    (link) => link.position === painting.frontmatter.position
  );

  const hasNext = !!paintingLinks[currentPageIndex - 1];
  const hasPrevious = !!paintingLinks[currentPageIndex + 1];

  const nextPage = hasNext
    ? paintingLinks[currentPageIndex - 1]
    : paintingLinks[paintingLinks.length - 1];
  const previousPage = hasPrevious
    ? paintingLinks[currentPageIndex + 1]
    : paintingLinks[0];

  return (
    <Layout>
      <Seo title={painting.frontmatter.title} />
      <Nav />
      <section className={styles.main}>
        <nav className={styles.paintingNav}>
          <Link
            to={`/wall-paintings/${previousPage.slug}`}
            className={styles.paintingNavLink}
            key={previousPage.slug}
          >
            <img
              className={styles.navArrow}
              src={arrow}
              alt="Previous"
            />
          </Link>
          <Link
            to={`/wall-paintings/${nextPage.slug}`}
            className={styles.paintingNavLink}
            key={nextPage.slug}
          >
            <img
              className={`${styles.navArrow} ${styles.next}`}
              src={arrow}
              alt="Next"
            />
          </Link>
        </nav>
        <section className={styles.paintingInfo}>
          <h2 className={styles.paintingTitle}>{painting.frontmatter.title}</h2>
          <MDXRenderer>{painting.body}</MDXRenderer>
        </section>
        {painting?.frontmatter?.painting_images?.map((image) => (
          <GatsbyImage
            key={image.id}
            className={styles.paintingImage}
            image={getImage(image)}
            alt="preview"
            objectFit="contain"
            placeholder="none"
          />
        ))}
      </section>
    </Layout>
  );
};

export default WallPaintingPage;

export const wallPaintingQuery = graphql`
  query WallPaintingQuery($id: String) {
    mdx(id: { eq: $id }) {
      body
      slug
      frontmatter {
        title
        position
        painting_images {
          childImageSharp {
            id
            gatsbyImageData
          }
        }
      }
    }
    allMdx(
      filter: { fields: { collection: { eq: "wallPaintings" } } }
      sort: { fields: frontmatter___position }
    ) {
      nodes {
        slug
        frontmatter {
          position
        }
      }
    }
  }
`;
